import React from "react";
import "./hero.scss";

// Heights (0–1) for each bar column — two mirrored rows create symmetry
const BAR_HEIGHTS = [
  0.3,
  0.55,
  0.8,
  0.45,
  1,
  0.65,
  0.35,
  0.9,
  0.5,
  0.75,
  0.4,
  1,
  0.6,
  0.85,
  0.3,
  0.7,
  0.55,
  0.95,
  0.4,
  0.65,
  0.3,
  0.8,
  0.5,
  1,
  0.45,
  0.7,
  0.35,
  0.9,
  0.6,
  0.75,
];

function PodCastHeroBanner({ bannerData }) {
  return (
    <div className="heroBanner hero-banner-wrap">
      {/* Animated waveform background */}
      <div className="hero-waveform" aria-hidden="true">
        {BAR_HEIGHTS.map((h, i) => (
          <span
            key={i}
            className="hero-waveform-bar"
            style={{
              "--bar-max": h,
              animationDelay: `${((i * 0.09) % 1.2).toFixed(2)}s`,
              animationDuration: `${(0.9 + (i % 5) * 0.15).toFixed(2)}s`,
            }}
          />
        ))}
      </div>

      {/* Radial glow overlays */}
      <div className="hero-glow hero-glow--left" aria-hidden="true" />
      <div className="hero-glow hero-glow--right" aria-hidden="true" />

      <div className="bannerOverlay">
        <div className="container">
          <div className="bannerPosition">
            <span className="podcast-badge">Podcast</span>
            <h1 className="heading-title">{bannerData?.title}</h1>
            <div className="item-flex">
              <p>{bannerData?.subtitle}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave transitioning into dark about section */}
      <svg
        className="hero-wave-svg"
        viewBox="0 0 1440 70"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d="M0,40 C360,80 1080,0 1440,40 L1440,70 L0,70 Z"
          fill="#ffffff"
        />
      </svg>
    </div>
  );
}

export default PodCastHeroBanner;
